import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { axiosInstnace as Axios } from "../../util/util";
import { endPoints } from "../../config";

import NoData from "../admin/common/NoData";
import Drag from "./dragNdDrop";
import { event } from "jquery";

const GetClientDetailModel = ({ isShown, hide, close }) => {
  //Set initial state
  const [clientName, handleClientName] = useState(undefined);
  const [clientEmail, handleClientEmail] = useState(undefined);
  const [clientCompany, handleClientCompany] = useState(undefined);
  const [clientIndustry, handleClientIndustry] = useState(undefined);
  const [clientState, handleClientState] = useState(undefined);
  const [clientCity, handleClientCity] = useState(undefined);
  const [clientPAN, handleClientPAN] = useState(undefined);
  const [clientPANFile, handleClientPANFile] = useState(undefined);
  const [clientGST, handleClientGST] = useState(undefined);
  const [clientGSTFile, handleClientGSTFile] = useState(undefined);
  const [clientAddress, handleClientAddress] = useState(undefined);
  const [clientAddressProof, handleClientAddressProof] = useState(undefined);

  const [industryList, handleIndustryList] = useState([]);
  const [statesData, handleStatesData] = useState([]);
  const [citiesData, handleCitiesData] = useState([]);
  

  const [clientKYC, handleClientKYC] = useState({});

  const closePopup = () => {
    hide();
  };

  useEffect(() => {
    getIndustryList();
    getStatesData();
  }, []);

  const handleChange = (event) => {
    let { name, value } = event.target;
    let kycObj = clientKYC;
    
    this.setState({
      kycObj: {
        ...kycObj,
        [name]: value,
      },
    });
    
  };

  const getIndustryList = async () => {
    const response = await Axios.get(`${endPoints.getIndustryList}`);
    let industryListData = response.data.data.data;
    handleIndustryList(industryListData);
  };

  const getStatesData = async () => {
    let states = await Axios.get(endPoints.getStateList);
    handleStatesData(states.data.data.data);
  };
  
  const getCityList = async (state) => {
    let cities = await Axios.get(`${endPoints.getCities}?state=${state}`);
    handleCitiesData(cities.data.data.data);
  }

  const getUploadedClientFile = (file, handler) => {

  }




  const submitClientKYC = (e) => {
    e.preventDefault();
    
    if(!clientName || !clientEmail || !clientCompany || !clientIndustry || !clientState || !clientCity || !clientPAN || !clientPANFile || !clientGST || !clientGSTFile || !clientAddress || !clientAddressProof){
      toast.warn("Please fill all fields and try to submit again", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: false,
          toastId: "1",
      });
      return false;
    }
    
    // handleClientKYC()
    hide({
      clientName,
      clientEmail,
      clientCompany,
      clientIndustry,
      clientState,
      clientCity,
      clientPAN,
      clientPANFile,
      clientGST,
      clientGSTFile,
      clientAddress,
      clientAddressProof,
    });
    // handleClientKYC([]);
  }

  return isShown ? (
    <div className="dashboardContainer remark-popup">
      <div className="modal-overlay">
        <div
          className="modal-wrapper existing-audio-popup"
          aria-modal
          aria-hidden
          role="dialog"
        >
          <form className="form-group">
            <div className="modal">
              <div className="modal-head-cross rate-modal">
                <button
                  type="button"
                  className="modal-close-button"
                  onClick={(e)=>{
                    close();
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="editNonFct-header modal-header">
                  <div className="running_cap_head">
                    <h2 className="camp_head">Client Details</h2>
                  </div>
                </div>

                <div className=" modal-body">
                  <div className="bg-white">
                    <div className="popupCampaign-container">
                      <div className="campaign-input master-inputs nonFct">
                        <div className="dashboard-content userListing-dashboard bg-white table-responsive">
                          <table style={{ width: "100%" }}>
                            <tr>
                              <td>
                                <div className="">
                                  <div className="field_wrapper kyc_input_inner width95">
                                    <h6 className="camp_label">Name</h6>
                                    <input
                                        type="text"
                                        name="client_pan_number"
                                        placeholder="Enter client's name"
                                        onChange={ (e)=> handleClientName(e.target.value) }
                                        required
                                    />
                                    </div>
                                </div>
                              </td>
                              <td>
                                <div className="">
                                  <div className="field_wrapper kyc_input_inner width95">
                                    <h6 className="camp_label">Email</h6>
                                    <input
                                        type="text"
                                        name="client_pan_number"
                                        placeholder="Enter client's Email"
                                        onChange={ (e)=> handleClientEmail(e.target.value) }
                                        required
                                    />
                                    </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="">
                                  <div className="field_wrapper kyc_input_inner width95">
                                    <h6 className="camp_label">Company</h6>
                                    <input
                                        type="text"
                                        name="client_pan_number"
                                        placeholder="Enter client's company name"
                                        onChange={ (e)=> handleClientCompany(e.target.value) }
                                        required
                                    />
                                    </div>
                                </div>
                              </td>
                              <td>
                                <div className="">
                                  <div className="field_wrapper kyc_input_inner width95">
                                    <h6 className="camp_label">Industry</h6>
                                    <select
                                      className="typeDropdown drop-down-icon width200"
                                      onChange={(e) => {
                                        handleClientIndustry(e.target.value);
                                      }}
                                    >
                                      {industryList.map((e)=>(
                                        <option value={ e.name }>{ e.name }</option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="">
                                  <div className="field_wrapper kyc_input_inner width95">
                                    <h6 className="camp_label">State</h6>
                                    <select
                                      className="typeDropdown drop-down-icon width200"
                                      onChange={(e) => {
                                        handleClientState(e.target.value);
                                        getCityList(e.target.value);
                                      }}
                                    >
                                      {statesData.map((e)=>{
                                        return   <option value={e}>{e}</option> 
                                      })}
                                    </select>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="">
                                  <div className="field_wrapper kyc_input_inner width95">
                                    <h6 className="camp_label">City</h6>
                                    <select
                                      className="typeDropdown drop-down-icon width200"
                                      onChange={(e) => {
                                        handleClientCity(e.target.value);
                                        
                                      }}
                                    >
                                      {citiesData.map((e)=>{
                                        return  <option value={e.value}>{e.value}</option> 
                                      })}
                                    </select>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="">
                                  <div className="field_wrapper kyc_input_inner width95">
                                    <h6 className="camp_label">Pan Number</h6>
                                    <input
                                        type="text"
                                        name="client_pan_number"
                                        placeholder="Enter client's PAN Number"
                                        onChange={ (e)=> handleClientPAN(e.target.value) }
                                        required
                                    />
                                    </div>
                                </div>
                              </td>
                              <td>
                                <div className="lenght_file_wrapper ">
                                  <div className="flie_audio">
                                  
                                    { !clientPANFile && (
                                      <div>
                                        <h6 className="camp_label">
                                          PAN Certificate
                                        </h6>
                                        <input type="file" name="pan_file" onChange={ (e)=> { handleClientPANFile(e.target.files[0]) } } accept=".jpeg, .png, .jpg, .svg" />
                                      </div>
                                    )}
                                      
                                    { clientPANFile && (
                                      <div className="upload_file">
                                          <h6 className="camp_label">
                                            Uploaded PAN File
                                          </h6>
                                          <div>
                                          <div className="audio_img">
                                              {" "}
                                              <img src="../../assets/images/song.svg" />
                                          </div>
                                          <div className="file_desc">
                                              <div className="file_name_size">
                                                <div className="file_name">
                                                    { clientPANFile && clientPANFile.path }
                                                </div>
                                              </div>
                                              <div
                                                className="remove_file"
                                                onClick={ (e) => { handleClientPANFile(undefined) } }
                                                >
                                                  <a>REMOVE</a>
                                              </div>
                                          </div>
                                          </div>
                                      </div>
                                      )}
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="field_wrapper kyc_input_inner width95">
                                    <h6 className="camp_label">GST Number</h6>
                                    <input
                                      type="text"
                                      name="client_gst_Number"
                                      placeholder="Enter client's GST Number"
                                      onChange={ (e)=> { handleClientGST(e.target.value) } }
                                    />
                                </div>
                                </td>
                                <td>
                                  <div className="lenght_file_wrapper">
                                    <div className="flie_audio">
                                    
                                      { !clientGSTFile &&  (
                                        <div>
                                            <h6 className="camp_label">
                                              GST Certificate
                                            </h6>
                                            <input type="file" name="gst_file" onChange={ (e)=> { handleClientGSTFile(e.target.files[0]) } } accept=".jpeg, .png, .jpg, .svg" />
                                        </div>
                                      )}
                                        
                                      { clientGSTFile && (
                                        <div className="upload_file">
                                            <h6 className="camp_label">
                                            Uploaded GST File
                                            </h6>
                                            <div>
                                              <div className="audio_img">
                                                  {" "}
                                                  <img src="../../assets/images/song.svg" />
                                              </div>
                                              <div className="file_desc">
                                                <div className="file_name_size">
                                                  <div className="file_name">
                                                      { clientGSTFile && clientGSTFile.path }
                                                  </div>
                                                </div>
                                                <div
                                                  className="remove_file"
                                                  onClick={ (e)=> { handleClientGSTFile(undefined) }}
                                                  >
                                                    <a>REMOVE</a>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </td>
                            </tr>
                            <tr>
                              <td>
                                  <div className="pad-top-20">
                                  <h6 className="camp_label">
                                      Billing Address
                                  </h6>
                                  <textarea
                                      className="gst_address"
                                      rows="3"
                                      cols="30"
                                      name="client_billing_Address"
                                      onChange={ (e) => { handleClientAddress(e.target.value) } }
                                      placeholder="Enter client's Billing Address"
                                  ></textarea>
                                  </div>
                              </td>
                              <td align="top" className="vAlignTop">
                                  <div className="lenght_file_wrapper pad-top-20">
                                    <div className="flie_audio">

                                      { !clientAddressProof &&
                                        (<div>
                                          <h6 className="camp_label">
                                              Billing Addres Proof
                                          </h6>
                                          <input type="file" name="address_proof_file" onChange={ (e)=> { handleClientAddressProof(e.target.files[0]) } } accept=".jpeg, .png, .jpg, .svg" />
                                        </div>
                                      )}

                                      { clientAddressProof && (
                                        <div className="upload_file">
                                          <h6 className="camp_label">
                                              Uploaded Billing Addres
                                          </h6>
                                          <div>
                                            <div className="audio_img">
                                              {" "}
                                              <img src="../../assets/images/song.svg" />
                                            </div>
                                            <div className="file_desc">
                                              <div className="file_name_size">
                                                <div className="file_name">
                                                  { clientAddressProof && clientAddressProof.path }
                                                </div>
                                                {/* <span className="file_size">
                                                  {client_bill_address_cert_file
                                                      ? client_bill_address_cert_file.size
                                                      : null}
                                                </span> */}
                                              </div>
                                              <div
                                                  className="remove_file"
                                                  onClick={ () => { handleClientAddressProof(undefined) } }
                                              >
                                                <a>REMOVE</a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      
                                    </div>
                                  </div>
                              </td>
                            </tr>
                          
                          </table>
                        </div>
                        <div className="create_camp_btn" style={{width: "100%", marginTop: "50px"}}>
                          <button style={{float: "right"}} onClick={(e)=>{submitClientKYC(e)}}>Submit</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  ) : null;
};

export default GetClientDetailModel;



// WEBPACK FOOTER //
// ./web/components/campaign/getClientDetailModel.js